//import React from 'react';
//import { Line } from 'react-chartjs-2';

//import Chart from 'react-apexcharts';

// ChartComponent.js
import React from 'react';
import ReactApexChart from 'react-apexcharts';

import ReactCountryFlag from "react-country-flag"


const FutureCurves = () => {
  // Sample data
  const series = [{
    name: '30 Sep 23',
    data: [6.08, 8.35, 10.22, 11.29, 12.02, 12.30]
  }, {
    name: '31 Mar 24',
    data: [7.01, 9.15, 11.22, 12.29, 13.52, 14.30]
  }, {
    name: '31 Dec 23',
    data: [6.49, 8.75, 10.82, 11.89, 12.82, 13.30]
  }
  ];

  const options = {
    chart: {
      height: 350,
      type: 'line',
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2
      },
      toolbar: {
        show: false
      }
    },
    colors: ['#dc3545', '#198754', '#FF6D00'],
    dataLabels: {
      enabled: true,
    },
    stroke: {
      curve: 'straight'
      //dashArray: [15, 5, 2] // Set the dash pattern to dashed line
    },
    title: {
      text: 'Future curves',
      align: 'left'
    },
    grid: {
      borderColor: '#e7e7e7',
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5
      },
    },
    markers: {
      size: 1
    },
    xaxis: {
      categories: ['Dec23', 'Dec24', 'Dec25', 'Dec26', 'Dec27', 'Dec28'],
      title: {
        text: 'Expiration month'
      }
    },
    yaxis: {
      title: {
        text: 'USD per lb.'
      },
      min: 6,
      max: 14.5
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5
    }

  };



  return (
    <>
      <div>
        <ReactCountryFlag
          countryCode='br'
          svg
          style={{ height: '0.8em' }}
        /> BRA Arabica &#x2022; Organic &#x2022; Fairtrade
        <ReactApexChart options={options} series={series} type="line" height={350} />
      </div>
    </>
  );
};

export default FutureCurves;
